import { CLEAR_DOCUMENT_DESCRIPTORS } from 'core/actions/constants'

const clearDocumentDescriptors = () => (dispatch) =>
  dispatch({
    type: CLEAR_DOCUMENT_DESCRIPTORS,
  })

export default clearDocumentDescriptors
